export const GET_INVESTIGATION_REQUEST = 'GET_INVESTIGATION_REQUEST';
export const GET_INVESTIGATION_SUCCESS = 'GET_INVESTIGATION_SUCCESS';
export const GET_INVESTIGATION_FAIL = 'GET_INVESTIGATION_FAIL';